<mat-card appearance="outlined">
    <mat-card-content>
        @if (isEditing) {
            <textarea [(ngModel)]="text"></textarea>
        } @else {
            <markdown ngPreserveWhitespaces [data]="text" />
        }
    </mat-card-content>
    @if (canEdit) {
        <mat-card-actions>
            @if (!isEditing) {
                <button mat-button (click)="isEditing = true">
                    <mat-icon>edit</mat-icon>
                    {{ 'General.Edit' | translate }}
                </button>
            }
            @if (isEditing) {
                <button mat-button [disabled]="isSaving" (click)="save()">
                    <mat-icon>save</mat-icon>
                    {{ 'General.Save' | translate }}
                </button>
            }
        </mat-card-actions>
    }
</mat-card>
